import script from "./ProportionalWithdrawalInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProportionalWithdrawalInput.vue?vue&type=script&setup=true&lang=ts"

import "./ProportionalWithdrawalInput.vue?vue&type=style&index=0&id=34639ccc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34639ccc"]])

export default __exports__